import Vue from 'vue'
import Router from 'vue-router'
import wx from 'weixin-js-sdk';
import Home from '@/views/Home'
import Index from '@/views/Index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      meta:{
        index:0,
        title:'',
        needShare:false
      },
      component: Home,
    },
    {
      path: '/index.html',
      name: 'Index',
      meta:{
        index:0,
        title:'',
        needShare:false
      },
      component: Index,
    },
    {
      path: '/site/:id(\\d+).html',
      name: 'Site',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/Site')
    },
    {
      path: '/enroll/:id(\\d+).html',
      name: 'Enroll',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/Enroll')
    },
    {
      path: '/rank/:id(\\d+).html',
      name: 'Rank',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/Rank')
    },
    {
      path: '/center/:id(\\d+).html',
      name: 'Center',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/Center')
    },
    {
      path: '/enroll_suc/:id(\\d+).html',
      name: 'EnrollSuc',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/EnrollSuc')
    },
    {
      path: '/pay/:id(\\d+).html',
      name: 'Pay',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/Pay')
    },
    /*{
      path: '/center.html',
      name: 'Center',
      meta:{
        index:0,
        title:'我的'
      },
      component:() => import('@/views/Center')
    },*/
    /*{
      path: '/index.html',
      name: 'Index',
      meta:{
        index:0,
        title:'',
        needShare:false
      },
      component: Index,
    },
    {
      path: '/list/:id(\\d+).html',
      name: 'List',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/List')
    },
    {
      path: '/goods/:id(\\d+).html',
      name: 'Goods',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/Goods')
    },
    {
      path: '/order/:id(\\d+).html',
      name: 'Order',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/Order')
    },
    {
      path: '/orders.html',
      name: 'Orders',
      meta:{
        index:0,
        title:''
      },
      component:() => import('@/views/Orders')
    },*/
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/"
    }
  ]
});
router.beforeEach((to, from, next) => {
  //用你的方式获取登录的用户信息
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if(!document.title){
    document.title='2026年全民健身社区运动会 现代五项大众障碍跑';
  }
  next()
})
router.afterEach((to,form)=>{
  setTimeout(function (){
    /*document.querySelector('#app').scrollTo(0, 0);*/
    window.scrollTo(0, 0);
  },200);
  /*wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
    wx.showMenuItems({
      menuList: [
        'menuItem:share:appMessage',
        'menuItem:share:timeline'
      ]
    });
    wx.updateAppMessageShareData({
      title: '致敬热血 为爱奔跑', // 分享标题
      desc: '2023无偿献血健康公益跑', // 分享描述
      link: 'http://rexue.fengtusports.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'http://rexue.fengtusports.cn/images/share_img.jpg', // 分享图标
      success: function () {
        // 设置成功
      }
    });
    wx.updateTimelineShareData({
      title: '“致敬热血 为爱奔跑”—— 2023无偿献血健康公益跑', // 分享标题
      link: 'http://rexue.fengtusports.cn/', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'http://rexue.fengtusports.cn/images/share_img.jpg', // 分享图标
      success: function () {
        // 设置成功
      }
    });
  });*/
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js